module.exports = __webpack_public_path__ + "static/sport/mb-bottom.cc3c9d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mb-bottom.png
// module id = iW/n
// module chunks = 0